import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    borderBottom: [1, 'solid', theme.palette.colors.divider],
    padding: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      padding: theme.spacing(4),
      '& button': {
        visibility: 'hidden',
      },
      '&:hover': {
        backgroundColor: theme.palette.colors.lightGray,
        '& button': {
          visibility: 'visible',
        },
      },
    },
    height: 110,
  },
  checkBox: {
    marginRight: theme.spacing(1),
  },
  mainBox: {
    display: 'flex',
    alignItems: 'center',
  },
  loanOfficerInfo: {
    width: 200,
  },
  loanOfficerBadge: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 110,
    marginLeft: theme.spacing(3),
    [theme.breakpoints.up('mobile')]: {
      width: 200,
    },
  },
  name: {
    marginTop: 4,
  },
  label: {
    color: theme.palette.colors.darkBlueGray,
    marginTop: 4,
  },
  approveButton: {
    height: 40,
    fontSize: 12,
    [theme.breakpoints.up('mobile')]: {
      fontSize: 'unset',
    },
  },
  tag: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    '&:last-child': {
      marginRight: 0,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/WaitlistLoanOfficersList/components/LoanOfficerCard/useStyles.js